import { useState } from 'react';
import { Button } from '../../atoms/legacy/Button';
import { Select, SelectOption } from '../../atoms/legacy/Select';

type Survey = {
  description: string;
  date_start: string;
  id: number;
};

export type ExportSurveyResponsesProps = {
  surveys: string;
};

/**
 * @deprecated This component was migrated from Preact and should not be used or refactored.
 * It does not comply with our current architectural patterns (compound components, proper separation of concerns, etc.).
 * These legacy components will be migrated in due course.
 */
export function ExportSurveyResponses({ surveys }: ExportSurveyResponsesProps) {
  const parsedSurveys: Survey[] = JSON.parse(surveys);
  const normalizedSurveys: SelectOption[] = Array.isArray(parsedSurveys)
    ? parsedSurveys.map((survey) => ({
        label: `${survey.id} - ${survey.description.substring(0, 50)}${
          survey.description.length > 50 ? '...' : ''
        } (${new Date(survey.date_start).toLocaleDateString()})`,
        value: survey.id,
      }))
    : [];

  const [selectedSurvey, setSelectedSurvey] = useState(
    normalizedSurveys[0]?.value?.toString() || '',
  );

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    window.open(`/HektorBox/exportSurvey?survey=${selectedSurvey}`, '_blank')?.focus();
  };

  return (
    <form className="flex flex-col gap-2" onSubmit={handleSubmit}>
      <Select
        label="Export des réponses au sondage"
        options={normalizedSurveys}
        value={selectedSurvey}
        setValue={setSelectedSurvey}
      />

      <Button type="submit">Télécharger les réponses</Button>
    </form>
  );
}
